import React, { useEffect, useState } from 'react'
import { Routes, Route, useParams, Outlet, useLocation, Navigate } from 'react-router'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import RentInfoHome from './RentInfoHome'
import RentInfoDetails from './RentInfoDetails'
import { getRentPaymentList } from '../Property_Api'
import { property_View } from '../View_Property/View_Property_Api'
import Swal from 'sweetalert2'
import {
  subdivisionListDataType,
  rentPaymentListDataType,
  memoizedRentPaymentListDataType,
  memoizedSubRentPaymentList,
} from './RestInfoDataType'
import { CircularProgress } from '@mui/material'
import PaginationComponent from '../../PaginationComponent/Pagination'
import UtilityDetailsModal from './Components/UtilityDetailsModal'
import BulkUtilityUploadModal from '../BulkUtilityUploadModal'

const profileBreadCrumbs: Array<PageLink> = [
  { title: 'Rent Information', path: '/property', isSeparator: false, isActive: false },
  { title: '', path: '', isSeparator: true, isActive: false },
]
const RentInfoRoutes = () => {
  const { id } = useParams()
  const location = useLocation()
  const [subdivisionList, setSubdivisionList] = useState<subdivisionListDataType[]>()
  const [memoizedSubRentPaymentList, setMemoizedSubRentPaymentList] =
    useState<memoizedSubRentPaymentList>({})
  const [memoizedRentPaymentList, setMemoizedRentPaymentList] =
    useState<memoizedRentPaymentListDataType>({})
  const [rentPaymentList, setRentPaymentList] = useState<rentPaymentListDataType[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [showBulkUploadModal, setShowBulkUploadModal] = useState<Boolean>(false)
  const [propertyName, setPropertyName] = useState<string>('')
  const [propertyUUID, setPropertyUUID] = useState<string>('')
  const [subdivisionRendered, setSubdivisionRendered] = useState<string>('')
  const [subdivisionName, setSubdivisionName] = useState<string>('')
  const [resetData, setResetData] = useState<boolean>(false)
  const [showUtilityModal, setShowUtilityModal] = useState<boolean>(false)
  const [itemOffset, setItemOffset] = useState<number>(0)
  const [dataLength, setDataLength] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const itemsPerPage = 6
  const pageCount = Math.ceil(dataLength / itemsPerPage)

  const getTenantRentPaymentList = async (
    id: string,
    property_sub_unit_uuid: string,
    forceReFetch: boolean
  ) => {
    // setLoading(true)
    if (id && subdivisionList) {
      if (subdivisionList.length > 0) {
        if (subdivisionRendered !== location.pathname) {
          setItemOffset(0)
          setCurrentPage(1)
          if (
            property_sub_unit_uuid &&
            memoizedSubRentPaymentList.hasOwnProperty(property_sub_unit_uuid) &&
            memoizedSubRentPaymentList[property_sub_unit_uuid][1] &&
            !forceReFetch
          ) {
            setRentPaymentList(memoizedSubRentPaymentList[property_sub_unit_uuid][1].data)
            setDataLength(memoizedSubRentPaymentList[property_sub_unit_uuid][1].totalRecords)
            setLoading(false)
            return
          } else {
            try {
              const { data: response } = await getRentPaymentList(
                id,
                property_sub_unit_uuid,
                0,
                itemsPerPage
              )
              if (response.code === '200') {
                setMemoizedSubRentPaymentList({
                  ...memoizedSubRentPaymentList,
                  [property_sub_unit_uuid]: {
                    ...memoizedSubRentPaymentList[property_sub_unit_uuid],
                    1: {
                      data: response.data.rentList,
                      lastUpdated: formatDate(new Date()),
                      totalRecords: response.data.totalRentList,
                    },
                  },
                })
                setRentPaymentList(response.data.rentList)
                setDataLength(response.data.totalRentList)
              } else if (response.code === '204') {
                setMemoizedSubRentPaymentList({
                  ...memoizedSubRentPaymentList,
                  [property_sub_unit_uuid]: {
                    1: {
                      data: [],
                      lastUpdated: formatDate(new Date()),
                      totalRecords: 0,
                    },
                  },
                })
                setDataLength(0)
                setRentPaymentList(response.data)
              }
            } catch (error: any) {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: error,
              })
            } finally {
              setLoading(false)
            }
          }
        } else {
          if (
            property_sub_unit_uuid &&
            memoizedSubRentPaymentList.hasOwnProperty(property_sub_unit_uuid) &&
            memoizedSubRentPaymentList[property_sub_unit_uuid][currentPage] &&
            !forceReFetch
          ) {
            setRentPaymentList(memoizedSubRentPaymentList[property_sub_unit_uuid][currentPage].data)
            setDataLength(memoizedSubRentPaymentList[property_sub_unit_uuid][1].totalRecords)
            setLoading(false)
            return
          } else {
            try {
              const { data: response } = await getRentPaymentList(
                id,
                property_sub_unit_uuid,
                itemOffset,
                itemsPerPage
              )
              if (response.code === '200') {
                setMemoizedSubRentPaymentList({
                  ...memoizedSubRentPaymentList,
                  [property_sub_unit_uuid]: {
                    ...memoizedSubRentPaymentList[property_sub_unit_uuid],
                    [currentPage]: {
                      data: response.data.rentList,
                      lastUpdated: formatDate(new Date()),
                      totalRecords: response.data.totalRentList,
                    },
                  },
                })
                setRentPaymentList(response.data.rentList)
                setDataLength(response.data.totalRentList)
              } else if (response.code === '204') {
                setMemoizedSubRentPaymentList({
                  ...memoizedSubRentPaymentList,
                  [property_sub_unit_uuid]: {
                    1: {
                      data: [],
                      lastUpdated: formatDate(new Date()),
                      totalRecords: 0,
                    },
                  },
                })
                setDataLength(0)
                setRentPaymentList(response.data)
              }
            } catch (error: any) {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: error,
              })
            } finally {
              setLoading(false)
            }
          }
        }
      } else {
        if (memoizedRentPaymentList.hasOwnProperty(currentPage) && !forceReFetch) {
          setRentPaymentList(memoizedRentPaymentList[currentPage].data)
          setLoading(false)
          return
        } else {
          try {
            const { data: response } = await getRentPaymentList(
              id,
              property_sub_unit_uuid,
              itemOffset,
              itemsPerPage
            )
            if (response.code === '200') {
              setMemoizedRentPaymentList({
                ...memoizedRentPaymentList,
                [currentPage]: {
                  data: response.data.rentList,
                  lastUpdated: formatDate(new Date()),
                },
              })
              setRentPaymentList(response.data.rentList)
              setDataLength(response.data.totalRentList)
            } else if (response.code === '204') {
              setMemoizedRentPaymentList({
                1: {
                  data: [],
                  lastUpdated: formatDate(new Date()),
                },
              })
              setRentPaymentList(response.data)
              setDataLength(0)
            } else {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
                text: response.msg_details,
                allowOutsideClick: true,
              })
            }
          } catch (error: any) {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: error,
            })
          } finally {
            setLoading(false)
          }
        }
      }
      setSubdivisionRendered(location.pathname)
    }
  }

  const get_view_property = async () => {
    if (id) {
      try {
        const { data: response } = await property_View(id)
        if (response.code === '200') {
          setSubdivisionList(response.data[0].sub_units)
          setPropertyName(response.data[0].property_title)
          setPropertyUUID(response.data[0].property_uuid)
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
            text: response.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      }
    }
  }
  // GetUtilityType
  useEffect(() => {
    get_view_property()
  }, [])

  useEffect(() => {
    if (id && subdivisionList) {
      if (subdivisionList.length > 0) {
        subdivisionList?.map((subdivision) => {
          if (location.pathname === `/property/rent_info/${id}/${subdivision.property_sub_unit_uuid}`) {
            getTenantRentPaymentList(id, subdivision.property_sub_unit_uuid, false)
            setSubdivisionName(subdivision.property_sub_unit_uuid)
          }
        })
      } else {
        getTenantRentPaymentList(id, '', false)
      }
      setSubdivisionRendered(location.pathname)
    }
  }, [subdivisionList, location.pathname, resetData])
  useEffect(() => {
    if (id && subdivisionList) {
      if (subdivisionRendered === location.pathname && itemOffset !== 0) {
        if (subdivisionList.length > 0) {
          subdivisionList?.map((subdivision) => {
            if (
              location.pathname === `/property/rent_info/${id}/${subdivision.property_sub_unit_uuid}`
            ) {
              getTenantRentPaymentList(id, subdivision.property_sub_unit_uuid, false)
              setSubdivisionName(subdivision.property_sub_unit_uuid)
            }
          })
        } else {
          getTenantRentPaymentList(id, '', false)
        }
      }
      else if (subdivisionRendered === location.pathname && itemOffset === 0 && subdivisionList.length > 0 && memoizedSubRentPaymentList.hasOwnProperty(subdivisionName) &&
        memoizedSubRentPaymentList[subdivisionName].hasOwnProperty(currentPage)) {
        subdivisionList?.map((subdivision) => {
          if (
            location.pathname === `/property/rent_info/${id}/${subdivision.property_sub_unit_uuid}`
          ) {
            getTenantRentPaymentList(id, subdivision.property_sub_unit_uuid, false)
            setSubdivisionName(subdivision.property_sub_unit_uuid)
          }
        })
      }
      else if (subdivisionRendered === location.pathname && itemOffset === 0 && subdivisionList.length === 0 && memoizedRentPaymentList.hasOwnProperty(currentPage)) {
        getTenantRentPaymentList(id, '', false)
      }
    }
  }, [itemOffset])

  const refreshData = () => {
    setItemOffset(0)
    setCurrentPage(1)
    setSubdivisionRendered(location.pathname)
    setResetData(!resetData)
    if (subdivisionList && subdivisionList?.length > 0) {
      delete memoizedSubRentPaymentList[subdivisionName]
    } else {
      setMemoizedRentPaymentList({})
    }
  }

  function formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    }
    return new Intl.DateTimeFormat('en-US', options).format(date)
  }
  return (
    <>
      <Routes>
        <Route
          element={
            <>
              {subdivisionList && subdivisionList.length > 0 && (
                <>
                  {
                    propertyName && <p className='breadcrumb text-muted fs-6 fw-bold pb-4'>Property: {propertyName}</p>
                  }
                  <RentInfoHome id={id} subdivisionList={subdivisionList} />
                </>
              )}
              <Outlet />
            </>
          }
        >
          {id &&
            subdivisionList &&
            subdivisionList.map((sub_division, index) => {
              return (
                <>
                  <Route
                    key={index}
                    path={sub_division.property_sub_unit_uuid}
                    element={
                      <>
                        {loading ? (
                          // {* Begin: loader*}
                          <div
                            className='d-flex justify-content-center align-items-center vh-70'
                            style={{ height: '70vh' }}
                          >
                            <CircularProgress />
                          </div>
                        ) : (
                          // {* End: loader*}
                          <>
                            <div className='d-flex justify-content-end'>
                              <div className='d-inline-flex justify-content-center align-items-center flex-wrap'>
                                <span className='me-2'>
                                  {memoizedSubRentPaymentList.hasOwnProperty(subdivisionName) &&
                                    memoizedSubRentPaymentList[subdivisionName].hasOwnProperty(
                                      currentPage
                                    ) && (
                                      <p className='my-1'>
                                        {`Last updated 
                                ${memoizedSubRentPaymentList[subdivisionName][currentPage].lastUpdated}`}
                                      </p>
                                    )}
                                </span>
                                <button
                                  type='button'
                                  className='py-1 my-2 btn btn-sm fw-bold btn-primary me-3'
                                  onClick={refreshData}
                                >
                                  <i className='bi bi-arrow-repeat text-white fs-4'></i>
                                  <span className='me-2'>Refresh</span>
                                </button>
                                <button type='button'
                                  className='py-1 my-2 btn btn-sm fw-bold btn-primary py-3 me-3'
                                  onClick={() => setShowUtilityModal(true)}>
                                  Add Utility Details
                                </button>
                                <button type='button'
                                  className='py-1 my-2 btn btn-sm fw-bold btn-primary py-3'
                                  onClick={() => setShowBulkUploadModal(true)}>
                                  Bulk Utility upload
                                </button>
                                {
                                  showUtilityModal &&
                                  <UtilityDetailsModal
                                    show={showUtilityModal}
                                    handleClose={() => setShowUtilityModal(false)}
                                    property_sub_unit_uuid={sub_division.property_sub_unit_uuid}
                                    propertyUUID={propertyUUID}
                                    getTenantRentPaymentList={getTenantRentPaymentList}
                                    id={id}
                                  />
                                }
                                {
                                  showBulkUploadModal &&
                                  <BulkUtilityUploadModal
                                    show={showBulkUploadModal}
                                    handleClose={() => setShowBulkUploadModal(false)}
                                    refreshTableAPI={() => getTenantRentPaymentList(id, sub_division.property_sub_unit_uuid, true)} />
                                }
                              </div>
                            </div>
                            <RentInfoDetails
                              rentPaymentList={rentPaymentList}
                              getTenantRentPaymentList={getTenantRentPaymentList}
                            />

                            {rentPaymentList.length > 0 && pageCount > 1 && (
                              <PaginationComponent
                                itemsPerPage={itemsPerPage}
                                dataLength={dataLength}
                                setItemOffset={setItemOffset}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                pageCount={pageCount}
                              />
                            )}
                          </>
                        )}

                        {/* <PageTitle breadcrumbs={profileBreadCrumbs}> */}
                        <PageTitle>
                          {sub_division.property_unit_name}
                        </PageTitle>
                      </>
                    }
                  ></Route>
                  <Route path='*' element={<Navigate to='/404' />} /></>
              )
            })}
          {subdivisionList && subdivisionList.length > 0 && (
            <Route
              index
              element={
                <Navigate
                  to={`/property/rent_info/${id}/${subdivisionList[0].property_sub_unit_uuid}`}
                  replace={true}
                />
              }
            ></Route>
          )}
          {id && subdivisionList && (
            <>
              <Route
                index
                element={
                  <>
                    {loading ? (
                      // {* Begin: loader*}
                      <div
                        className='d-flex justify-content-center align-items-center vh-70'
                        style={{ height: '70vh' }}
                      >
                        <CircularProgress />
                      </div>
                    ) : (
                      <>
                        {/* // {* End: loader*} */}
                        {/* <div className='d-flex align-self-end justify-content-xl-end me-2 my-2 rounded-7'>
                        <button type='button' onClick={refreshData}>
                          <i className='bi bi-arrow-repeat text-dark fs-1'></i>
                        </button>
                      </div> */}
                        <div className='d-flex justify-content-end'>
                          <div className='d-inline-flex justify-content-center align-items-center flex-wrap'>
                            <span className='me-2'>
                              {memoizedRentPaymentList.hasOwnProperty(currentPage) && (
                                <p className='my-1'>
                                  {`Last updated 
                                ${memoizedRentPaymentList[currentPage].lastUpdated}`}
                                </p>
                              )}
                            </span>
                            <button
                              type='button'
                              className='py-1 my-2 btn btn-sm fw-bold btn-primary text-white me-3'
                              onClick={refreshData}
                            >
                              <i className='bi bi-arrow-repeat text-white fs-4'></i>
                              <span className='me-2'>Refresh</span>
                            </button>
                            <button type='button'
                              className='py-1 my-2 btn btn-sm fw-bold btn-primary py-3 me-3'
                              onClick={() => setShowUtilityModal(true)}>
                              Add Utility Details
                            </button>
                            <button type='button'
                              className='py-1 my-2 btn btn-sm fw-bold btn-primary py-3'
                              onClick={() => setShowBulkUploadModal(true)}>
                              Bulk Utility upload
                            </button>
                            {
                              showUtilityModal &&
                              <UtilityDetailsModal
                                show={showUtilityModal}
                                handleClose={() => setShowUtilityModal(false)}
                                property_sub_unit_uuid=""
                                propertyUUID={propertyUUID}
                                getTenantRentPaymentList={getTenantRentPaymentList}
                                id={id} />
                            }
                            {
                              showBulkUploadModal &&
                              <BulkUtilityUploadModal
                                show={showBulkUploadModal}
                                handleClose={() => setShowBulkUploadModal(false)}
                                refreshTableAPI={() => getTenantRentPaymentList(id, "", true)} />
                            }
                          </div>
                        </div>
                        <RentInfoDetails
                          rentPaymentList={rentPaymentList}
                          getTenantRentPaymentList={getTenantRentPaymentList}
                        />
                        {rentPaymentList.length > 0 && pageCount > 1 && (
                          <PaginationComponent
                            itemsPerPage={itemsPerPage}
                            dataLength={dataLength}
                            setItemOffset={setItemOffset}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            pageCount={pageCount}
                          />
                        )}
                      </>
                    )}
                    {/* <PageTitle breadcrumbs={profileBreadCrumbs}>{propertyName}</PageTitle> */}
                    <PageTitle>{propertyName}</PageTitle>
                  </>
                }
              ></Route>
              <Route path='*' element={<Navigate to='/404' />} />
            </>
          )}
        </Route>
      </Routes>
    </>
  )
}

export default RentInfoRoutes
